import React from "react";
import "../Assets/Styles/Footer.scss";
import { Col, Nav, Row } from "react-bootstrap";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import YouTubeIcon from '@material-ui/icons/YouTube';
import GitHubIcon from "@material-ui/icons/GitHub";
import InstaGramIcon from '@material-ui/icons/Instagram';


const Footer = () => {
  return (
    <div className="footer pb-5 pt-5 ">
      <div className="container">
        <Row className="justify-content-between align-items-center">
          <Col md={3} xs={12}>
            <div className="d-flex justify-content-between footer-info mt-4">
            <Nav.Link
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/in/sachidanand-shah-7589a4142/"
                  className="nav-item cursor-pointer"
                  target="_blank"
                  aria-label="Linkedin"
                >
                 <LinkedInIcon/>
                </Nav.Link>
                <Nav.Link
                  rel="noopener noreferrer"
                  href="https://github.com/Sachidanand9"
                  className="nav-item cursor-pointer"
                  aria-label="Github"
                  target="_blank"
                >
                  <GitHubIcon />
                </Nav.Link>
               
                <Nav.Link
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/@sachii_i"
                  className="nav-item cursor-pointer"
                  target="_blank"
                  aria-label="Youtube"
                >
                  <YouTubeIcon/>
                </Nav.Link>

                <Nav.Link
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/_sachuu_u/"
                  className="nav-item cursor-pointer"
                  target="_blank"
                  aria-label="Youtube"
                >
                  <InstaGramIcon/>
                </Nav.Link>

                
                <Nav.Link
                  rel="noopener noreferrer"
                  href="https://www.hackerrank.com/Sachiii"
                  className="nav-item cursor-pointer"
                  target="_blank"
                  aria-label="hackerrank"
                >
                  <img
                    height="25px"
                    src="images/hr.png"
                    alt="icon"
                  />
                </Nav.Link>

                <Nav.Link
                  rel="noopener noreferrer"
                  href="https://profile.codingninjas.com/5ff11f7a-dedd-4827-a4fa-7eccb281a3c5?_ga=2.30188031.1326639508.1667740014-379739096.1662820511&_gac=1.26605647.1666693443.Cj0KCQjwkt6aBhDKARIsAAyeLJ01MHHiy3sOicMZeARa25qq2hKQGq5IsnIcPRh6PsqrioAs2oD8mfIaAiE_EALw_wcB"
                  className="nav-item cursor-pointer"
                  target="_blank"
                  aria-label="CodingNinjas"
                >
                  <img
                    height="25px"
                    src="images/cn.jpg"
                    alt="icon"
                  />
                </Nav.Link>
                
            </div>
          </Col>
          <Col md={4} xs={12}>
            <ul className="d-flex justify-content-between p-0 w-100 footer-info mt-4 ">
              <li className="p-1">
                <a rel="noopener noreferrer" href="#home">Home</a>
              </li>
              <li className="p-1">
                <a rel="noopener noreferrer" href="#about">About</a>
              </li>
              <li className="p-1">
                <a rel="noopener noreferrer" href="#skills">Skills</a>
              </li>
              <li className="p-1">
                <a rel="noopener noreferrer" href="#projects">Projects</a>
              </li>
              <li className="p-1">
                <a rel="noopener noreferrer" href="#contact">Contact</a>
              </li>
            </ul>
          </Col>
        </Row>
        <div className="text-center mt-4  footer-end">
          <p>
            Designed & Developed by{" "}
            <span className="chonburi-font green-text"> Sachidanand Shah</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
